var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "root-contrast" },
    [
      _c("route-name", { attrs: { propsRouteName: "合同在线起草" } }),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("div", { staticClass: "search" }, [
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", plain: "", size: "small" },
                    on: { click: _vm.draftUp }
                  },
                  [
                    _c("i", { staticClass: "el-icon-upload" }),
                    _vm._v("   上传文件")
                  ]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small", plain: "" },
                    on: {
                      click: function() {
                        _vm.$router.push({ path: "/smartDoc/docDraft/draft" })
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "el-icon-document-add" }),
                    _vm._v("   选择模板")
                  ]
                ),
                _c(
                  "el-button",
                  { attrs: { size: "small" }, on: { click: _vm.delDoc } },
                  [
                    _c("i", { staticClass: "el-icon-delete" }),
                    _vm._v("   删除文件")
                  ]
                )
              ],
              1
            ),
            _c(
              "div",
              [
                _c("el-input", {
                  attrs: {
                    placeholder: "请输入文件名",
                    size: "small",
                    clearable: ""
                  },
                  model: {
                    value: _vm.fileName,
                    callback: function($$v) {
                      _vm.fileName = $$v
                    },
                    expression: "fileName"
                  }
                }),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "10px" },
                    attrs: { size: "small" },
                    on: {
                      click: function($event) {
                        return _vm.searchData(1)
                      }
                    }
                  },
                  [_vm._v("查询")]
                ),
                _c(
                  "el-button",
                  { attrs: { size: "small" }, on: { click: _vm.rest } },
                  [_vm._v("重置")]
                )
              ],
              1
            )
          ]),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.TableLoading,
                  expression: "TableLoading"
                }
              ],
              staticStyle: { "min-height": "64vh" },
              attrs: { data: _vm.drafData, border: "" },
              on: {
                "selection-change": function(rows) {
                  this$1.selected = rows
                }
              }
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "45" }
              }),
              _c("el-table-column", {
                attrs: { prop: "docIndex", width: "50", label: "序号" }
              }),
              _c("el-table-column", {
                attrs: { prop: "contractName", label: "合同名称" }
              }),
              _c("el-table-column", {
                attrs: { prop: "createTime", label: "合同起草时间" }
              }),
              _c("el-table-column", {
                attrs: { prop: "updateTime", label: "最后修改时间" }
              }),
              _c("el-table-column", {
                attrs: { label: "状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          {
                            style: {
                              color: _vm.drafStatus[scope.row.draftStatus].color
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.drafStatus[scope.row.draftStatus].status
                              )
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.draftStatus == 1
                          ? _c(
                              "span",
                              {
                                staticClass: "action pointer",
                                on: {
                                  click: function($event) {
                                    return _vm.toComplete(scope.row)
                                  }
                                }
                              },
                              [_vm._v("立即加入")]
                            )
                          : _vm._e(),
                        scope.row.fggUserFlag == "super" &&
                        scope.row.draftStatus == 1
                          ? _c(
                              "span",
                              {
                                staticClass: "action pointer",
                                on: {
                                  click: function($event) {
                                    return _vm.aboutAdd(scope.row)
                                  }
                                }
                              },
                              [_vm._v("添加相关方")]
                            )
                          : _vm._e(),
                        scope.row.fggUserFlag == "super" &&
                        scope.row.draftStatus == 1
                          ? _c(
                              "span",
                              {
                                staticClass: "action pointer",
                                on: {
                                  click: function($event) {
                                    return _vm.toComplete(scope.row)
                                  }
                                }
                              },
                              [_vm._v("完成")]
                            )
                          : _vm._e(),
                        scope.row.draftStatus == 2
                          ? _c(
                              "span",
                              {
                                staticClass: "action pointer",
                                on: {
                                  click: function($event) {
                                    return _vm.toComplete(scope.row)
                                  }
                                }
                              },
                              [_vm._v("查看详情")]
                            )
                          : _vm._e(),
                        scope.row.draftStatus == 2 &&
                        scope.row.fggUserFlag == "super"
                          ? _c(
                              "span",
                              {
                                staticClass: "action pointer",
                                on: {
                                  click: function($event) {
                                    return _vm.draftAgain(scope.row)
                                  }
                                }
                              },
                              [_vm._v("再次起草")]
                            )
                          : _vm._e(),
                        scope.row.draftStatus == 2 &&
                        scope.row.fggUserFlag == "super"
                          ? _c(
                              "span",
                              {
                                staticClass: "action pointer",
                                on: {
                                  click: function($event) {
                                    return _vm.contractUp(scope.row)
                                  }
                                }
                              },
                              [_vm._v("合同发起")]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c("el-row", [
            _c(
              "div",
              { staticClass: "page-sty page-flex-end" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.pageModel.page,
                    "page-sizes": [10, 20, 50, 100],
                    "page-size": _vm.pageModel.pageSize,
                    layout: "sizes, prev, pager, next, total",
                    total: _vm.pageModel.total
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange
                  }
                }),
                _c("el-go", {
                  attrs: {
                    "page-size": _vm.pageModel.pageSize,
                    total: _vm.pageModel.total
                  },
                  on: { "current-change": _vm.handleCurrentChange }
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "添加相关方", visible: _vm.ADDVisible, width: "40%" },
          on: {
            "update:visible": function($event) {
              _vm.ADDVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "propos-box" },
            _vm._l(_vm.propos, function(item, i) {
              return _c(
                "el-form",
                { key: i, attrs: { model: item, inline: "" } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "phoneOrEmail",
                        label: "合同拟定方" + (i + 1) + ": ",
                        rules: _vm.propRule
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { "padding-left": "15px" },
                        attrs: {
                          clearable: "",
                          size: "small",
                          placeholder: "请输入邮箱/手机号"
                        },
                        on: {
                          input: function($event) {
                            return _vm.partAdd(i, $event)
                          }
                        },
                        model: {
                          value: item.phoneOrEmail,
                          callback: function($$v) {
                            _vm.$set(item, "phoneOrEmail", $$v)
                          },
                          expression: "item.phoneOrEmail"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "名称: ",
                        rules: [
                          {
                            required: true,
                            message: "请输入名称",
                            trigger: "blur"
                          }
                        ]
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { "padding-left": "15px" },
                        attrs: { size: "small", placeholder: "请输入名称" },
                        model: {
                          value: item.userName,
                          callback: function($$v) {
                            _vm.$set(item, "userName", $$v)
                          },
                          expression: "item.userName"
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c("div", { staticClass: "propos-action" }, [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.propos.length - 1 > 0,
                            expression: "propos.length - 1 > 0"
                          }
                        ],
                        staticStyle: { "margin-right": "20px" },
                        attrs: { src: "/images/AISmart/icon/del.png", alt: "" },
                        on: {
                          click: function($event) {
                            return _vm.delItem(item)
                          }
                        }
                      }),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.propos.length - 1 == i,
                            expression: "propos.length - 1 == i"
                          }
                        ],
                        attrs: {
                          src: "/images/AISmart/icon/puls.png",
                          alt: ""
                        },
                        on: { click: _vm.addItem }
                      })
                    ])
                  ])
                ],
                1
              )
            }),
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.ADDCancel } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.ADDSubmit } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a2bef90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a2bef90","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/smartDoc/docDraft/draftList.vue
// module id = th+U
// module chunks = 128